import { graphql } from '../gql';

export const getCompletedDeliveryEventDetails = graphql(`
  query GetCompletedDeliveryEventDetails($input: GetEventVendorsInput!) {
    getEventVendors(input: $input) {
      error {
        code
        message
      }
      eventVendors {
        __typename
        id
        productType
        ... on SelectEventVendor {
          configuredCapacity
          currentOrders
          expectedOrders
          vendor {
            id
            internalName
            address {
              id
              address1
              address2
              city
              state
              zipCode
              country
            }
          }
          menuTemplate {
            id
          }
          selectEvent {
            id
            startTime: endTime
            endTime: deliveryTime
            status
            readyAndBaggedTime
            mealPeriod
            account {
              id
              name
            }
            location {
              id
              name
              building {
                id
                name
                address {
                  id
                  address1
                  address2
                  city
                  state
                  zipCode
                  country
                }
              }
            }
          }
          preManifestDocument {
            id
            documentType
            documentUrl
            status
            confirmationToken
            confirmationUrl
            manifestDate
          }
          finalManifestDocument {
            id
            documentType
            documentUrl
            status
            confirmationToken
            confirmationUrl
            manifestDate
          }
          summaryItemCount
          summaryOrderCount
          summaryFoodSalesCents
          summaryTaxCents
          summaryTaxRemittedByFoodaCents
          summaryCommissionCents
          summaryPpFeesCents
          summaryPreliminaryEventTotalCents
        }
      }
    }
  }
`);
